import * as React from 'react';
const IconPrint = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    style={{ width: '24px', height: '25px' }}
    viewBox="0 0 24 25"
    fill="none"
    {...props}
  >
    <path
      d="M18.1695 1.58843e-06L5.8171 5.08547e-07L5.8171 9.10486L18.1695 9.10486L18.1695 1.58843e-06ZM15.9301 6.8715L8.05651 6.8715L8.05651 5.51796L15.9301 5.51796L15.9301 6.8715ZM15.9301 3.59141L8.05651 3.59141L8.05651 2.23786L15.9301 2.23786L15.9301 3.59141Z"
      fill="#020000"
    />
    <path
      d="M2.2171 19.3647L4.00595 19.3647C4.00595 19.3783 4.00595 19.3873 4.00595 19.4008L4.00595 21.6477C4.00595 23.4976 5.49145 25 7.32045 25L16.6706 25C18.4996 25 19.9851 23.4976 19.9851 21.6477L19.9851 19.4008C19.9851 19.4008 19.9851 19.3783 19.9851 19.3647L21.774 19.3647C23.0052 19.3647 24 18.3541 24 17.1133L24 7.99044C24 6.74517 23.0007 5.73904 21.774 5.73904L19.7844 5.73904L19.7844 10.7923L4.21562 10.7923L4.21562 5.73904L2.22602 5.73904C0.994798 5.73904 1.59549e-06 6.74968 1.48702e-06 7.99043L6.89474e-07 17.1133C5.8061e-07 18.3586 0.999259 19.3647 2.22602 19.3647L2.2171 19.3647ZM5.79034 16.617L18.2364 16.617L18.2141 21.6477C18.2141 22.5095 17.5182 23.2133 16.6662 23.2133L7.31599 23.2133C6.46394 23.2133 5.76803 22.5095 5.76803 21.6477L5.79034 16.617Z"
      fill="#020000"
    />
  </svg>
);
export default IconPrint;
